module.exports = __webpack_public_path__ + "images/borent_small004b55127493f199d7e447345507bae9.png";